'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.slider = twentyninetimes.slider || function () {

	function init() {
		const swiper = new Swiper('.swiper', {
			// Optional parameters
			direction: 'horizontal',
			loop: true,
		  
			// If we need pagination
			pagination: {
			  el: '.swiper-pagination',
			  type: "fraction",
			},
			grabCursor: true,
			spaceBetween: 30,
		  
			// Navigation arrows
			navigation: {
			  nextEl: '.js-slider-next',
			  prevEl: '.js-slider-prev',
			},
		  });
	}

	return {
		init : init
	};

}();